<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content "
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-2"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text"
          v-on="on"
        >
          <v-img
            v-if="avatar"
            :src="avatar"
          />
          <v-icon
            v-else
            color="primary"
            size="28"
          >
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-avatar>
      </v-badge>
    </template>

    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img
              v-if="avatar"
              :src="avatar"
            />
            <v-icon
              v-else
              icon="mdi-account-outline"
              color="primary"
              size="28"
            >
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-avatar>
        </v-badge>

        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="text--primary font-weight-semibold mb-n1"> {{ nome }} </span>
        </div>
      </div>

      <v-divider class="my-2"></v-divider>

      <v-list-item
        :key="isDark"
        @click="isDark = !isDark"
      >
        <v-list-item-icon class="me-2">
          <v-icon>
            {{ isDark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content> {{ isDark ? 'Light Mode' : 'Dark Mode' }} </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <v-list-item @click="logoutUser">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Sair</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiAccountOutline, mdiLogoutVariant, mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'
import { useRouter } from '@core/utils'
import useAppConfig from '@core/@app-config/useAppConfig'
import { storeToRefs } from 'pinia'
import useUserStore from '@/store/user'
import { clearDataStores } from '@/utils/store'

export default {
  setup() {
    const { isDark } = useAppConfig()
    const { router } = useRouter()

    const { nome, avatar } = storeToRefs(useUserStore())

    function logoutUser() {
      clearDataStores()
      router.push({ name: 'auth-login' })
    }

    return {
      isDark,
      nome,
      avatar,
      logoutUser,
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
        mdiAccountOutline,
        mdiLogoutVariant,
      },
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
